// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.session.Session

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { ProjectData, ProjectStore } from "./Project.generated";
import { ManagedRepositoryData, ManagedRepositoryStore } from "./ManagedRepository.generated";
import { PhysicalRepositoryData, PhysicalRepositoryStore } from "./PhysicalRepository.generated";
import { SandboxContainerData, SandboxContainerStore } from "./SandboxContainer.generated";
import { SandboxData, SandboxStore } from "./Sandbox.generated";
import { SSHKeysCatalogData, SSHKeysCatalogStore } from "./SSHKeysCatalog.generated";

export interface SessionData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "Session";
    project: ProjectData | null;
    container: ManagedRepositoryData | PhysicalRepositoryData | SandboxContainerData | null;
    root_sandbox: SandboxData;
    ssh_keys: SSHKeysCatalogData;
}

export class SessionStore {
    readonly _entity_class_name = "Session" as const;
    project: ProjectStore | null;
    container: ManagedRepositoryStore | PhysicalRepositoryStore | SandboxContainerStore | null;
    root_sandbox: SandboxStore;
    ssh_keys: SSHKeysCatalogStore;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: SessionData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.project = wrapEntity(data.project, transport, [...chainPath, "project"]) ?? null;
        this.container = wrapEntity(data.container, transport, [...chainPath, "container"]) ?? null;
        this.root_sandbox = wrapEntity(data.root_sandbox, transport, [...chainPath, "root_sandbox"]);
        this.ssh_keys = wrapEntity(data.ssh_keys, transport, [...chainPath, "ssh_keys"]);
        makeObservable(this, {
            project: observable,
            container: observable,
            root_sandbox: observable,
            ssh_keys: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async reconcile(data: Record<string, any>): Promise<any> {
        return callRpc(this._transport, this._chainPath, "reconcile", [data], {});
    }

    async select_project(path: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "select_project", [path], {});
    }

    async select_managed_project(repo_url: string): Promise<any> {
        return callRpc(this._transport, this._chainPath, "select_managed_project", [repo_url], {});
    }

    async close(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "close", [], {});
    }

    async unselect_project(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "unselect_project", [], {});
    }
}

registerEntity("Session", SessionStore);
